import { createUseStyles } from 'react-jss';
export default createUseStyles({
    root: {
        animation: '$rotate 2s linear infinite'
    },
    path: {
        strokeDasharray: '1, 200',
        strokeDashoffset: 0,
        animation: '$dash 1.5s ease-in-out infinite',
        strokeLinecap: 'round',
        strokeWidth: 3,
        strokeMiterlimit: 10,
        stroke: function (props) { return props.color; }
    },
    '@keyframes dash': {
        '0%': {
            strokeDasharray: '1, 200',
            strokeDashoffset: 0
        },
        '50%': {
            strokeDasharray: '89, 200',
            strokeDashoffset: '-35px'
        },
        '100%': {
            strokeDasharray: '89, 200',
            strokeDashoffset: '-124px'
        }
    },
    '@keyframes rotate': {
        '100%': {
            transform: 'rotate(360deg)'
        }
    }
}, { name: 'CircleSpinnerIcon' });
//# sourceMappingURL=styles.js.map